import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,_vm._g(_vm._b({staticClass:"vd-back-btn",class:{
		'px-0': !_vm.dark,
		'pr-1': !_vm.dark && !_vm.hideBackIcon
	},attrs:{"text":!_vm.dark,"dark":_vm.dark,"color":_vm.dark ? 'white' : 'primary',"outlined":_vm.dark}},'VBtn',_vm.$attrs,false),_vm.$listeners),[_vm._t("icon",function(){return [(!_vm.hideBackIcon)?_c(VIcon,{staticClass:"mr-1",class:{ 'ml-n1': _vm.dark },attrs:{"color":_vm.dark ? 'white' : 'primary'}},[_vm._v(" "+_vm._s(_vm.backIcon)+" ")]):_vm._e()]}),_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.locales.label)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }